import { ICellRendererParams } from 'ag-grid-community';
import { Glyphicon, OverlayTrigger, Popover, DropdownButton, MenuItem } from 'react-bootstrap';
import { PopoverWrapper } from './overlays';
import { ProductActionType } from '../show';
import { ICenterSaturation, IProduct, IProductCenterForList } from '@nkr/models/index';
import { PopoverTableWrapper } from '../styles';
import { SaturationSummaryRenderer } from './saturation-summary-renderer';

interface IProps extends ICellRendererParams {
    productAlias: string,
    products?: IProduct[],
    productCenters?: IProductCenterForList[],
    onItemClicked: (centerId: number, productAlias: string, action: ProductActionType) => void,
    onCloseProduct: (centerId: number, productAlias: string) => void,
    onDeleteProduct: (centerId: number, productAlias: string) => void,
}

export const SaturationRenderer = (props: IProps) => {
    let data = props.data as ICenterSaturation;
    let colId = props.column.getColDef().colId;
    let product = props.products != undefined ? props.products.find(x => x.alias.toUpperCase() == props.productAlias) : null;
    let pc = product != null ? props.productCenters.find(x => x.centerId == data.id && x.productId == product.id) : null;

    const renderChecksNoOverlay = (productValue: number) => {
        if (productValue == 3) {
            return <Glyphicon glyph='ok' />;
        }

        if (productValue == 2) {
            return <Glyphicon glyph='ok' style={{ color: 'red' }} title='This product is active but the product plan is not closed' onClick={() => props.onCloseProduct(data.id, props.productAlias)} />;
        }

        if (props.value == 1) {
            if (pc != null) {
                return (
                    <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={
                        <Popover>
                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{ paddingRight: 10 }}>Date Closed:</td>
                                        <td className='text-right'>{pc.closeDate}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ paddingRight: 10 }}>Closed By:</td>
                                        <td className='text-right'>{pc.closedBy}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Popover>
                    } rootClose>
                        <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />
                    </OverlayTrigger>
                );
            } else {
                return <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />;
            }
        }

        if (productValue == 0) {
            return <div className='target' style={{ paddingLeft: 5 }} title='This product can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>
            </div>;
        }

        return (
            <span className='targeted'>
                <DropdownButton
                    bsSize='xs'
                    title='T'
                    id={'tp-' + data.id + '-' + props.productAlias}
                    noCaret
                >
                    <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                    <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                    <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                    <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                </DropdownButton>
            </span>
        );
    }

    const renderChecks = (overlay: any) => {
        if (props.value == 3) {
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={overlay} rootClose>
                    <Glyphicon glyph='ok' />
                </OverlayTrigger>
            );
        }

        if (props.value == 2) {
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={overlay} rootClose>
                    <Glyphicon glyph='ok' style={{ color: 'red' }} title='This product is active but the product plan is not closed' onClick={() => props.onCloseProduct(data.id, props.productAlias)} />
                </OverlayTrigger>
            );
        }

        if (props.value == 1) {
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={overlay} rootClose>
                    <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />
                </OverlayTrigger>
            );
        }

        if (props.value == 0) {
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={overlay} rootClose>
                    <div className='target' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>&nbsp;</div>
                </OverlayTrigger>
            );
        }

        return (
            <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={overlay} rootClose>
                <span className='targeted'>
                    <DropdownButton
                        bsSize='xs'
                        title='T'
                        id={'tp-' + data.id + '-' + props.productAlias}
                        noCaret
                    >
                        <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                        <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                        <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                        <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                    </DropdownButton>
                </span>
            </OverlayTrigger>
        );
    }

    if (props.data.isSummary || props.data.isProductOwner) {
        return (
            <SaturationSummaryRenderer {...props} />
        );
    }

    switch (colId) {
        case 'awDashfU':
            const dashFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>DASH Registrations L 3 Months:</td>
                                <td className='text-right'>{data.dashCount}</td>
                            </tr>
                            <tr>
                                <td>LD TXP Volume (PY):</td>
                                <td className='text-right'>{data.livingDonorCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(dashFullyUtilizedItemOverlay);

        case 'awFUPfU':
            const automatedDonorFollowUpFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>F-Up Registrations L 90 Days:</td>
                                <td className='text-right'>{data.followupCount}</td>
                            </tr>
                            <tr>
                                <td>50% of LY Qrtly LD TXP Vol:</td>
                                <td className='text-right'>{(data.livingDonorCountQuarterly * 0.50).toLocaleString('en-us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(automatedDonorFollowUpFullyUtilizedItemOverlay);

        case 'otherDSDfU':
            const donorShieldDirectFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>DSD Registrations:</td>
                                <td className='text-right'>{data.dsdCaseCount}</td>
                            </tr>
                            <tr>
                                <td>DSD Registrations L 90:</td>
                                <td className='text-right'>{data.dsdL90CaseCount}</td>
                            </tr>
                            <tr>
                                <td>70% of DSD Registrations:</td>
                                <td className='text-right'>{(data.dsdCaseCount * 0.70).toFixed(0)}</td>
                            </tr>
                            <tr>
                                <td>NKR TXP Volume:</td>
                                <td className='text-right'>{data.txpCount}</td>
                            </tr>
                            <tr>
                                <td>NKR TXP Volume L 90:</td>
                                <td className='text-right'>{data.txpL90Count}</td>
                            </tr>
                            <tr>
                                <td>LY Quarterly LD TXP Volume:</td>
                                <td className='text-right'>{data.livingDonorCountQuarterly}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(donorShieldDirectFullyUtilizedItemOverlay);

        case 'adFVfU':
            const familyVoucherFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>FV Donations L 6 M:</td>
                                <td className='text-right'>{data.totalFamilyVouchers}</td>
                            </tr>
                            <tr>
                                <td>NDD Donations L 6 M:</td>
                                <td className='text-right'>{data.nddCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(familyVoucherFullyUtilizedItemOverlay);

        case 'dsMSfU':
            const micrositesFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>Microsite Registrations:</td>
                                <td className='text-right'>{data.micrositeCount}</td>
                            </tr>
                            <tr>
                                <td>Deceased Donor Waitlist:</td>
                                <td className='text-right'>{data.waitListCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(micrositesFullyUtilizedItemOverlay);

        case 'awPwlfU':
            const pwlFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>PWL L 3 M:</td>
                                <td className='text-right'>{data.pwlCount}</td>
                            </tr>
                            <tr>
                                <td>DASH L 3 M:</td>
                                <td className='text-right'>{data.dashCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(pwlFullyUtilizedItemOverlay);

        case 'adVPUt':
            const voucherProgramFullyUtilizedItemOverlay = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>Voucher Donations L 12 M:</td>
                                <td className='text-right'>{data.totalVouchers}</td>
                            </tr>
                            <tr>
                                <td>LD Tranplants L 12 M:</td>
                                <td className='text-right'>{data.livingDonorCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={voucherProgramFullyUtilizedItemOverlay} rootClose>
                        <span>{parseFloat(data.voucherProgramUtilization.toString()).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%'}</span>
                    </OverlayTrigger>
                </div>
            );

        case 'billACC':
            const automatedCollectionsAndClearing = (
                <Popover>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td># of Invoices:</td>
                                <td className='text-right'>{data.automatedCollectionsAndClearingInvoiceCount}</td>
                            </tr>
                            <tr>
                                <td>$ of Invoices:</td>
                                <td className='text-right'>{data.automatedCollectionsAndClearingTotalCharges.toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </Popover>
            );

            return renderChecks(automatedCollectionsAndClearing);

        case 'kflA':
            if (props.value == 3) {
                return <Glyphicon glyph='ok' />;
            }

            if (props.value == 2) {
                return <Glyphicon glyph='ok' style={{ color: 'red' }} title='This product is active but the product plan is not closed' onClick={() => props.onCloseProduct(data.id, props.productAlias)} />;
            }

            if (props.value == 1) {
                if (pc != null) {
                    return (
                        <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={
                            <Popover>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Date Closed:</td>
                                            <td className='text-right'>{pc.closeDate}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Closed By:</td>
                                            <td className='text-right'>{pc.closedBy}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Popover>
                        } rootClose>
                            <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />
                        </OverlayTrigger>
                    );
                } else
                    return <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />;
            }

            if (props.value == 0 && !data.utilizing3GTyping) {
                return <div className='target' title='This product can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>&nbsp;</div>;
            }

            if (props.value == 0 && data.utilizing3GTyping) {
                return <Glyphicon glyph='ok' style={{ color: 'yellow' }} title='This product is active but there are currently no High Res typing orders' />;
            }

            return (
                <span className='targeted'>
                    <DropdownButton
                        bsSize='xs'
                        title='T'
                        id={'tp-' + data.id + '-' + props.productAlias}
                        noCaret
                    >
                        <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                        <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                        <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                        <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                    </DropdownButton>
                </span>
            );

        case 'kflUt':
            const kidneyForLife = (
                <PopoverWrapper>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>Exportable Patients w/ High Res Typing:</td>
                                <td className='text-right'>{data.exportableRecipient3GTypingCount}</td>
                            </tr>
                            <tr>
                                <td>TX Patients w/ High Res Typing L 6 M:</td>
                                <td className='text-right'>{data.txpRecipient3GTypingCountL6M}</td>
                            </tr>
                            <tr>
                                <td>TX Patients L 6 Months (except for non-Voucher Holder Chips):</td>
                                <td className='text-right'>{data.txpCountNonAdpChipL6M}</td>
                            </tr>
                            <tr>
                                <td>Patients Exportable for at least 15 Days:</td>
                                <td className='text-right'>{data.exportableRecipientCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </PopoverWrapper>
            );

            if (data.utilizing3GTyping) {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={kidneyForLife} rootClose>
                            <span>{parseFloat(data.kidneyForLifeUtilization.toString()).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%'}</span>
                        </OverlayTrigger>
                        <div>{renderChecksNoOverlay(data.kidneyForLifeUtilizationProduct)}</div>
                    </div>
                );
            }

            return <>-</>;

        case 'billShbUt':
            let shbUtilized = (
                <PopoverWrapper>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>Total Invoices 3-9 Mths:</td>
                                <td className='text-right'>{data.invoiceCount3to9Months}</td>
                            </tr>
                            <tr>
                                <td>Total Eligible Swaps 3-9 Mths:</td>
                                <td className='text-right'>{data.shbEligibleCount3to9Months}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </PopoverWrapper>
            );

            var colValue = "";

            if (data.shbUtilized > 0)
                colValue = parseFloat(data.shbUtilized.toString()).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';
            else
                colValue = "";

            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={shbUtilized} rootClose>
                    <span>{colValue}</span>
                </OverlayTrigger>
            );

        case 'kflESfU':
            let expertSystemFullyUtilized = (
                <PopoverWrapper>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td><strong>Formula:</strong></td>
                                <td className='text-right'>(HR Low EMM Txps L12 / HR Txps L12) {">"} 80%:</td>
                            </tr>
                            <tr>
                                <td><strong>HR Low EMM Txps / HR Txps L12:</strong></td>
                                <td className='text-right'>{data.lowExpletTxpCountL12M} / {data.hrTxpCountL12}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </PopoverWrapper>
            );

            return renderChecks(expertSystemFullyUtilized);

        case 'drcr':
            var colValue = "";

            if (data.donorReferralConversionRate > 0)
                colValue = parseFloat(data.donorReferralConversionRate.toString()).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';
            else
                colValue = "-";

            return (
                <span>{colValue}</span>
            );

        case 'kflS':
            let kidneyForLifeSuccess = (
                <PopoverWrapper>
                    <PopoverTableWrapper>
                        <tbody>
                            <tr>
                                <td>Total Low &amp; 0 MM TXPs L12:</td>
                                <td className='text-right'>{data.lowExpletTxpCountL12M}</td>
                            </tr>
                            <tr>
                                <td>Total TXPs w/ High Res Typing:</td>
                                <td className='text-right'>{data.txpRecipient3GTypingCount}</td>
                            </tr>
                        </tbody>
                    </PopoverTableWrapper>
                </PopoverWrapper>
            );

            if (data.utilizing3GTyping) {
                var colValue = "";

                if (data.kidneyForLifeSuccess > 0)
                    colValue = parseFloat(data.kidneyForLifeSuccess.toString()).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';
                else
                    colValue = "-";

                return (
                    <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={kidneyForLifeSuccess} rootClose>
                        <span>{colValue}</span>
                    </OverlayTrigger>
                );
            }

            return <>-</>;

        case 'awCHBD':
            if (data.homeBloodDrawCountTarget == 3) {
                return props.value;
            }

            if (data.homeBloodDrawCountTarget == 2 && props.value > 0) {
                return <span style={{ color: 'red' }} title='This product is active but the product plan is not closed' onClick={() => props.onCloseProduct(data.id, props.productAlias)}>{props.value}</span>;
            }

            if (data.homeBloodDrawCountTarget == 1) {
                return <span style={{ color: '#0A590A' }}>{props.value}</span>;
            }

            if (data.homeBloodDrawCountTarget == 0 && props.value == 0) {
                return <div className='target' title='This product can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>&nbsp;</div>;
            }

            return (
                <span className='targeted'>
                    <DropdownButton
                        bsSize='xs'
                        title={props.value > 0 ? 'T (' + props.value + ')' : 'T'}
                        id={'tp-' + data.id + '-' + props.productAlias}
                        noCaret
                    >
                        <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                        <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                        <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                        <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                    </DropdownButton>
                </span>
            );

        case 'kflEs':
            if (props.value == 3) {
                return <Glyphicon glyph='ok' />;
            }

            if (props.value == 2) {
                return <Glyphicon glyph='ok' style={{ color: 'red' }} title='This product is active but the product plan is not closed' onClick={() => props.onCloseProduct(data.id, props.productAlias)} />;
            }

            if (props.value == 1) {
                if (pc != null) {
                    return (
                        <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={
                            <Popover>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Date Closed:</td>
                                            <td className='text-right'>{pc.closeDate}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Closed By:</td>
                                            <td className='text-right'>{pc.closedBy}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Popover>
                        } rootClose>
                            <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />
                        </OverlayTrigger>
                    );
                } else
                    return <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />;
            }

            if (props.value == 0) {
                return <div className='target' title='This product can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>&nbsp;</div>;
            }

            return (
                <span className='targeted'>
                    <DropdownButton
                        bsSize='xs'
                        title='T'
                        id={'tp-' + data.id + '-' + props.productAlias}
                        noCaret
                    >
                        <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                        <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                        <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                        <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                    </DropdownButton>
                </span>
            );

        case 'kflVem':
            let vemTotal = data.vemOptedOutCount + data.vemWantsMoreInfoCount + data.vemOptedInCount;
            let vemOptedOutPct = (data.vemOptedOutCount / vemTotal * 100).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';
            let vemWantsMoreInfoPct = (data.vemWantsMoreInfoCount / vemTotal * 100).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';
            let vemOptedInPct = (data.vemOptedInCount / vemTotal * 100).toLocaleString('en-us', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '%';

            const vemItemOverlay = (
                <PopoverWrapper>
                    <table className='table table-striped table-condensed' style={{ marginBottom: 0 }}>
                        <tbody>
                            <tr>
                                <td colSpan={3} className='bg-info text-center' style={{ borderTop: '0 none' }}>VEM Donor Choice</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 500 }}>Opted-Out</td>
                                <td className='text-right'>{data.vemOptedOutCount}</td>
                                <td className='text-right'>{vemOptedOutPct}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 500 }}>Wants More Info</td>
                                <td className='text-right'>{data.vemWantsMoreInfoCount}</td>
                                <td className='text-right'>{vemWantsMoreInfoPct}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 500 }}>Opted-In</td>
                                <td className='text-right' style={{ borderBottom: '1px solid #ddd' }}>{data.vemOptedInCount}</td>
                                <td className='text-right'>{vemOptedInPct}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 500 }}>VEM Total</td>
                                <td className='text-right'>{vemTotal}</td>
                                <td className='text-right'></td>
                            </tr>
                        </tbody>
                    </table>
                </PopoverWrapper>
            );

            return renderChecks(vemItemOverlay);

        case 'peMemberCenter':
        case 'peBillable':
        case 'peRdn':
        case 'peVxm':
        case 'peDonorProtectionAddendum':
        case 'pcPartnerCenter':
        case 'pcAllInAddendumSigned':
        case 'adFV':
        case 'adSV':
        case 'awDash':
        case 'awPwl':
        case 'awFUP':
        case 'awLiverDash':
        case 'seroSSA':
        case 'dsMS':
        case 'dsPTSGt0':
        case 'dsPTSGt2':
        case 'dsODC':
        case 'refD':
        case 'refP':
        case 'refMS':
        case 'refK4L':
        case 'refODC':
        case 'refDCN':
        case 'billSBS':
        case 'shbEliSwaps':
        case 'otherCLS':
        case 'otherDSD':
        case 'seroDDS':
            if (props.value == 3) {
                return <div className='target' title='This product is active but can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}><Glyphicon glyph='ok' /></div>;
            }

            if (props.value == 2) {
                return (
                    <span className='active-targeted'>
                        <DropdownButton
                            bsSize='xs'
                            title='T'
                            id={'tp-' + data.id + '-' + props.productAlias}
                            noCaret
                        >
                            <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                            <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                            <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                            <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                        </DropdownButton>
                    </span>
                );
            }

            if (props.value == 1) {
                if (pc != null) {
                    return (
                        <OverlayTrigger trigger={['hover', 'focus']} placement='left' overlay={
                            <Popover>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Date Closed:</td>
                                            <td className='text-right'>{pc.closeDate}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ paddingRight: 10 }}>Closed By:</td>
                                            <td className='text-right'>{pc.closedBy}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Popover>
                        } rootClose>
                            <div className='target' title='This product is active and the product plan is closed but the plan can be reopened' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Reopen)}><Glyphicon glyph='ok' style={{ color: '#179117' }} /></div>
                        </OverlayTrigger>
                    );
                } else
                    return <Glyphicon glyph='ok' style={{ color: '#179117' }} />;
            }

            if (props.value == 0) {
                return <div className='target' title='This product can be targeted' onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Add)}>&nbsp;</div>;
            }

            return (
                <span className='targeted'>
                    <DropdownButton
                        bsSize='xs'
                        title='T'
                        id={'tp-' + data.id + '-' + props.productAlias}
                        noCaret
                    >
                        <MenuItem onClick={() => props.onCloseProduct(data.id, props.productAlias)}>Close</MenuItem>
                        <MenuItem onClick={() => props.onDeleteProduct(data.id, props.productAlias)}>Delete</MenuItem>
                        <MenuItem onClick={() => props.onItemClicked(data.id, props.productAlias, ProductActionType.Edit)}>View Product Plan</MenuItem>
                        <MenuItem onClick={() => window.location.href = '/admin/center/' + data.id + '/account-plan'}>View Account Plan</MenuItem>
                    </DropdownButton>
                </span>
            );

        default:
            if (props.value == 3) {
                return <Glyphicon glyph='ok' />;
            }

            if (props.value == 2) {
                return <Glyphicon glyph='ok' style={{ color: 'red' }} title='This product is active but the product plan is not closed' />;
            }

            if (props.value == 1) {
                return <Glyphicon glyph='ok' style={{ color: '#0A590A' }} />;
            }

            return null;
    }
}